<template>
  <div class="product">

    <h1>Report Prodotto</h1>

      <div class="report">

        <div class="row">
            <div class="col-3">nome</div>
            <div class="col-9">{{name}}</div>
        </div>
        <div class="row">
            <div class="col-3">ean</div>
            <div class="col-9">{{ean}}</div>
        </div>
        <div class="row">
            <div class="col-3">sku</div>
            <div class="col-9">{{sku}}</div>
        </div>
        <div class="row">
            <div class="col-3">price</div>
            <div class="col-9">{{formatPrice(price)}}</div>
        </div>

      </div>

      <h3>Ultime quotazioni</h3>

      <div class="table-data" v-if="websites">
          <div v-for="website in websites" v-bind:key="website">
              <div class="row">
                  <div class="col-3" :class="website.name.replace(' ','-').toLowerCase()">{{ website.name }}</div>
                  <div class="col-3">{{formatPrice(website.lastprice.price)}}</div>
                  <div class="col-3">{{formatDate(website.lastprice.date)}}</div>
                  <div class="col-3"><a :href="website.url" target="_blank">vai</a></div>
              </div>
          </div>
      </div>

      <h3>Filtri</h3>

      <div class="filters">

        <div class="row">
            <div class="col-3">periodo</div>
            <div class="col-9">
                <select class="form-control" @change="handleChange($event)">
                    <option value="1">orario</option>
                    <option value="2">12 ore</option>
                    <option value="3">giornaliero</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-3">data da</div>
            <div class="col-9">
                <date-picker v-model="date1" :first-day-of-week="1" :lang="lang"></date-picker>
            </div>
        </div>

        <div class="row">
            <div class="col-3">data a</div>
            <div class="col-9">
                <date-picker v-model="date2" :first-day-of-week="1" :lang="lang"></date-picker>
            </div>
        </div>

        <div class="row">
            <div class="col-3">giorni</div>
            <div class="col-9">
                <input type="number" class="form-control" placeholder="Giorni" v-model="days" v-on:change="changeDays">
            </div>
        </div>

        <div class="text-center">
            <button class="app_btn" @click="getProduct">Carica</button>
        </div>

      </div>

      <div>
          <h3>Grafico</h3>
          <div class="chart">
              <line-chart :chart-data="datacollection" :options="options"></line-chart>
          </div>
          <h3>{{name}}</h3>
      </div>

      <div>
          <a v-on:click="printPDF()" class="app_btn d-block text-center mx-auto">Stampa PDF</a>
          <router-link v-bind:to="{ name: 'ReportProductTable', params: { sku: sku } }" class="app_btn d-block text-center mx-auto">Tabella</router-link>
          <router-link v-bind:to="{ name: 'ReportProducts' }" class="app_btn d-block text-center mx-auto">Torna alla lista</router-link>
      </div>

  </div>
</template>

<script>
import printJS from 'print-js'
import DatePicker from 'vue2-datepicker'
import ProductsService from '@/services/ProductsService'
import LineChart from './LineChart.js'
import moment from 'moment'
export default {
  name: 'ReportProductSku',
  components: { LineChart, DatePicker },
  data () {
    return {
        lang: 'it',
        period: 1,
        date1: moment().subtract(3, 'days'),
        date2: new Date(),
        // date2: new Date(),
        days: 3,
        name: '',
        ean: '',
        sku: '',
        price: 0,
        websites: {},
        websitesmap: [],
        dataseries: null,
        datacollection: null,
        options: {
            responsive: true,
            maintainAspectRatio: false,
            height: '800px',
            tooltips: {
                mode: 'index',
                intersect: false,
                itemSort: (a, b, data) => b.yLabel - a.yLabel
            },
            hover: {
                mode: 'nearest',
                intersect: true
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Data'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Euro'
                    }
                }]
            }
        }
    }
  },
  mounted () {
      this.getProduct()
  },
  methods: {
    fillData () {
        var labels = []
        var datasets = []
        /* var maxseries = 0
        var maxcount = 0
        for (var i in this.dataseries.data) {
            if (this.dataseries.data[i].data.length > maxcount) {
                maxcount = this.dataseries.data[i].data
                maxseries = i
            }
        } */
        for (var item of this.dataseries.periods) {
            // if (item.price > 0) {
                labels.push(this.formatDate(item))
            // }
        }
        // console.log(labels)
        for (var index in this.dataseries.data) {
            var dataset = {
                label: this.dataseries.data[index].name,
                backgroundColor: this.getColor(index),
                borderColor: this.getColor(index),
                fill: false
            }
            var dataArray = []
            for (var itemt of this.dataseries.data[index].data) {
                dataArray.push(itemt.price.toFixed(2))
            }
            dataset.data = dataArray
            if (dataset.data.length && this.dataseries.data[index].hidereport !== true) {
                datasets.push(dataset)
            }
        }
        this.datacollection = {
          labels: labels,
          datasets: datasets
        }
    },
    printPDF () {
        printJS({printable: 'line-chart', type: 'html', documentTitle: this.name})
    },
    changeDays () {
        if (this.days > 0) {
            this.date1 = moment().subtract(this.days, 'days')
        }
    },
    getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    getColor (index) {
        let colors = [
            '#E74C3C',
            '#8E44AD',
            '#3498DB',
            '#16A085',
            '#2ECC71',
            '#F1C40F',
            '#E67E22',
            '#A6ACAF',
            '#2E4053',
            '#17202A',
            '#641E16',
            '#512E5F',
            '#154360',
            '#0E6251',
            '#145A32',
            '#186A3B',
            '#7D6608',
            '#7E5109',
            '#6E2C00',
            '#000000',
            '#E74C3C',
            '#8E44AD',
            '#3498DB',
            '#16A085',
            '#2ECC71',
            '#F1C40F',
            '#E67E22',
            '#A6ACAF',
            '#2E4053',
            '#17202A',
            '#641E16',
            '#512E5F',
            '#154360',
            '#0E6251',
            '#145A32',
            '#186A3B',
            '#7D6608',
            '#7E5109',
            '#6E2C00',
            '#000000',
            '#E74C3C',
            '#8E44AD',
            '#3498DB',
            '#16A085',
            '#2ECC71',
            '#F1C40F',
            '#E67E22',
            '#A6ACAF',
            '#2E4053',
            '#17202A',
            '#641E16',
            '#512E5F',
            '#154360',
            '#0E6251',
            '#145A32',
            '#186A3B',
            '#7D6608',
            '#7E5109',
            '#6E2C00',
            '#000000'
        ]
        return colors[index]
    },
    async getProduct () {
      const response = await ProductsService.reportsku({
        sku: this.$route.params.sku
      })
      // console.log(response.data)
      this.name = response.data.name
      this.ean = response.data.ean
      this.sku = response.data.sku
      this.price = response.data.price
      this.websites = response.data.websites

      const response2 = await ProductsService.reportseries({
        sku: this.$route.params.sku,
        period: this.period,
        date1: Math.floor(new Date(this.date1) * 1),
        date2: Math.floor(new Date(this.date2) * 1)
      })
      // console.log(response2.data)
      this.dataseries = response2.data
      this.fillData()
    },
    handleChange (event) {
        this.period = event.target.value
    },
    formatPrice (value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDate (value) {
        var date = new Date(value)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    }
  }
}
</script>
<style type="text/css">
.report {
  margin-bottom: 20px;
}
.report div, .filters div {
  text-align: left;
}
.table-data {
  margin-bottom: 20px;
}
.table-data div {
  text-align: left;
}
.filters .row {
    margin-bottom: 10px;
}
.mx-datepicker {
  width: 100%!important;
}
.app_btn, .app_btn:link, .app_btn:hover {
  margin: 20px 0;
  background: #4d7ef7;
  color: #fff!important;
  padding: 10px 80px;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  max-width: 500px;
  border: none;
  cursor: pointer;
}
.fotocolombo, .fotocolombo-acquisto, .fotocolombo-bundle {
    color:#E74C3C!important;
}
#line-chart {
    height: 800px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportProductSku.vue